import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { ArrowRight, Download, Smartphone, Monitor, Tablet } from 'lucide-react'

const CTASection = () => {
  const apps = [
    {
      name: 'App do Aluno',
      icon: Smartphone,
      color: 'from-blue-500 to-cyan-500',
      description: 'Disponível para iOS e Android'
    },
    {
      name: 'App da Escola',
      icon: Monitor,
      color: 'from-green-500 to-emerald-500',
      description: 'Web, iOS e Android'
    },
    {
      name: 'App do Professor',
      icon: Tablet,
      color: 'from-purple-500 to-pink-500',
      description: 'Disponível para iOS e Android'
    }
  ]

  return (
    <section className="py-20 bg-gradient-to-br from-primary-600 via-primary-700 to-secondary-600 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-12"
          >
            <h2 className="text-3xl lg:text-5xl font-bold mb-6">
              Pronto para começar?
            </h2>
            <p className="text-xl text-primary-100 leading-relaxed">
              Escolha o app ideal para você e comece a transformar sua experiência 
              com natação hoje mesmo.
            </p>
          </motion.div>

          {/* Apps Grid */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12"
          >
            {apps.map((app, index) => (
              <div key={index} className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/20 transition-all duration-300">
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-r ${app.color} text-white mb-4`}>
                  <app.icon className="h-8 w-8" />
                </div>
                
                <h3 className="text-xl font-semibold mb-2">
                  {app.name}
                </h3>
                
                <p className="text-primary-100 mb-4">
                  {app.description}
                </p>
                
                <button className="w-full bg-white/20 hover:bg-white/30 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200 inline-flex items-center justify-center">
                  <Download className="mr-2 h-4 w-4" />
                  Download
                </button>
              </div>
            ))}
          </motion.div>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link 
              to="/contato" 
              className="bg-white text-primary-600 hover:bg-gray-100 font-semibold py-4 px-8 rounded-lg transition-colors duration-200 inline-flex items-center justify-center"
            >
              Solicitar Demo Gratuito
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
            
            <Link 
              to="/solucoes" 
              className="border-2 border-white text-white hover:bg-white hover:text-primary-600 font-semibold py-4 px-8 rounded-lg transition-colors duration-200 inline-flex items-center justify-center"
            >
              Ver Todas as Soluções
            </Link>
          </motion.div>

          {/* Trust Indicators */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="mt-12 pt-8 border-t border-white/20"
          >
            <p className="text-primary-100 text-sm">
              ✓ Apps gratuitos • ✓ Sem anúncios • ✓ Suporte completo • ✓ Atualizações regulares
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default CTASection
